import React, { useEffect, useState } from 'react'
import config from '../../config'
import qs from 'qs'
import jwt from 'jsonwebtoken'
import callapi from '../../helpers/callapi'
import Cookies from 'js-cookie'
import { Spinner } from 'react-bootstrap'

export default function LineLogin() {
  const [isLoading, setIsLoading] = useState(false)
  useEffect(() => {
    const queryString = new URLSearchParams(window.location.search)
    const params = Object.fromEntries(queryString)
    const data = {
      grant_type: 'authorization_code',
      code: params['code'],
      redirect_uri: `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}${window.location.pathname}`,
      client_id: config.lineClientId,
      client_secret: config.lineClientSecret,
    }
    setIsLoading(true)
    fetch('https://api.line.me/oauth2/v2.1/token', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: qs.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        const decodedIdToken = jwt.verify(data.id_token, config.lineClientSecret, {
          algorithms: ['HS256'],
          audience: config.client_id,
          issuer: 'https://access.line.me',
        })
        const lineUser = {
          name: decodedIdToken.name,
          image: decodedIdToken.picture,
          uid: decodedIdToken.sub,
          accessToken: data.access_token,
        }
        callapi({
          url: '/admins/login/line',
          body: lineUser,
        })
          .then((response) => {
            Cookies.set('uidinfo', JSON.stringify(response.user))
            Cookies.set('accessToken', response.accessToken)
            setIsLoading(false)
          })
          .catch((err) => {
            console.log(err)
            setIsLoading(false)
          })
      })
      .catch((err) => {
        setIsLoading(false)
      })
    return () => {}
  }, [])
  return (
    <>
      {!isLoading && Cookies.get('accessToken') ? (
        (window.location = '/')
      ) : (
        <div className="d-flex align-items-center justify-content-center" style={{ height: '100vh' }}>
          <div className="d-flex flex-column align-items-center">
            <Spinner animation="border" variant="info" size="xxl" style={{ zIndex: 1, width: 100, height: 100 }} />
            <h3 className="pt-3">กรุณารอสักครู่ ระบบกำลังดำเนินการ</h3>
          </div>
        </div>
      )}
    </>
  )
}
